<template>
    <div class="FormCertificate">
        <v-easy-dialog v-model="simpleDialog">
            <div class="flex flex-col v-card textSend">
            <div>
                <p class = "titleModal">
                    <strong>Confirmamos la recepción de la solicitud. A continuación los pasos a seguir para la emisión del certificado:</strong>
                </p>
            </div>
            <hr/>
            <div class = "infoModal">
                <p>
                1. Descarga tu recibo de pago.
                </p>
                <p>   
                    Recuerda que para emitir el comprobante de pago, debes estar a paz y salvo por todo concepto con la IBERO.
                </p>
                <p>
                    2. Una vez realizado el pago adjunta el soporte en <a href="http://campus.ibero.edu.co/recibo-pago-certificado" target="_blank"><strong>"Soporte de pago Certificaciones"</strong></a>. Ten en cuenta que debes tener a la mano el número de radicado de esta solicitud.
                </p>
                <p>
                    3. Después de recibido el comprobante de pago; inicia el trámite de expedición del certificado por parte del área de Registro y control en 2 días hábiles y para los certificados de practicas 6 dias habiles.
                </p>
            </div>

            <div class="flex justify-end space-x-2">
                <button id="btnClose" v-on:click="closeModal" style="float: right;">Descargar Recibo de Pago</button>
            </div>
            </div>
        </v-easy-dialog>
        <div v-if="FormCertificate">
            <div class="container container-form">
                <div class="row">
                    <div class="col-md-7 totalform motBusUser">  
                        <div v-if="infoData" class="alert alert-danger">
                            <p>
                                Estimado usuario. Tus datos no han podido ser validados por nuestro sistema de información. Te invitamos a comunicarte a nuestra línea de atención al 
                                estudiante 7466876 o a través del correo servicioalestudiante@ibero.edu.co.
                            </p>
                        </div>
                        <div v-if="infoCorrect" class="alert alert-success">
                            <p>
                                Gracias, Tu información ha sido recibida  con éxito, se ha creado el caso y será atendido lo más pronto posible.
                            </p>
                        </div>
                        <h1 class="titleForm"><strong>Certificaciones</strong></h1>
                        <p class="descriptionForm">
                            Para agilizar tus trámites y ahorrar tiempo puedes llenar el formulario a continuación para solicitar cualquier tipo de certificado que necesites. 
                            Ten en cuenta que utilizaremos el resto de tu información para actualizar tus datos y asegurarnos de poder estar siempre en contacto.
                        </p>
                        <ValidationObserver ref="obsformCertificate">
                            <FormCertificate :FieldsForm="formCertificate" :ModelForm="formInsModel" :method="executeProcess" />                                     
                        </ValidationObserver>
                        <div class="botoPnrocess">
                            <div class="container">
                                <div class="row">
                                    <div class="col-md-4"></div>
                                    <div class="col-md-4">
                                        <button
                                            id="UpdateUser"
                                            type="submit"
                                            v-on:click="UpdateUser"
                                            class="loginbtn">
                                            Validar datos
                                        </button>
                                    </div>
                                    <div class="col-md-4"></div>
                                </div>
                            </div>
                        </div>
                    </div> 
                    <div class="col-md-5 infoForm">
                        <FormDataInscription /> 
                    </div>
                </div>
            </div>
        </div>
        <div v-if="FormValidate">
            <div class="container container-form">
                <div class="row">
                    <div class="col-md-2 infoForm">
                    </div> 
                    <div class="col-md-8 totalform motBusUser">
                        <div v-if="dangerData" class="alert alert-danger">
                            <p>
                                Error: Tus datos no han sido almacenados correctamente. Te invitamos a comunicarte a nuestra línea de atención al estudiante 7426582 Opción 2 o a través del correo servicioalestudiante@ibero.edu.co. 
                            </p>
                        </div>
                        <div class="infoTitleValid">
                            <p><strong>NOTA:</strong> Recuerda que, una vez solicitado el certificado, no es posible hacer ajustes al mismo.</p>
                        </div>
                        <div class="wrapper">
                            <div>
                                <p><strong>Nombre(s)</strong></p>
                            </div>
                            <div>
                                <p>{{this.NamePerson}}</p>
                            </div>
                            <div>
                                <p><strong>Apellido(s)</strong></p>
                            </div>
                            <div>
                                <p>{{this.LastnamePerson}}</p>
                            </div>
                            <div>
                                <p><strong>Tipo de Identificación</strong></p>
                            </div>
                            <div>
                                <p>{{this.IdType}}</p>
                            </div>
                            <div>
                                <p><strong>N° de Identificación</strong></p>
                            </div>
                            <div>
                                <p>{{this.Identification}}</p>
                            </div>
                            <div>
                                <p><strong>Programa a Certificar</strong></p>
                            </div>
                            <div>
                                <p>{{this.Program}}</p>
                            </div>
                            <div>
                                <p><strong>Tipo de Certificado o Duplicado</strong></p>
                            </div>
                            <div>
                                <p>{{this.CertificateType}}</p>
                            </div>
                            <div>
                                <p><strong>Periodo Académico a Certificar</strong></p>
                            </div>
                            <div>
                                <p>{{this.PeriodCertificate}}</p>
                            </div>

                            <div>
                                <p><strong>Cantidad de Periodos</strong></p>
                            </div>
                            <div>
                                <p>{{this.QuantityCertificate}}</p>
                            </div>
                            <div>
                                <p><strong>Valor del Certificado</strong></p>
                            </div>
                            <div>
                                <p>${{this.ValueCertificate}}</p>
                            </div>
                        </div>
                        <div class="validate-data botoPnrocess">
                            <div class="container">
                                <p>
                                    ¿Estás de acuerdo con la información digitada es correcta?
                                </p>
                                <div class="row">
                                    <div class="col-md-4"></div>
                                    <div class="col-md-4">
                                        <button
                                            id="UpdateUser"
                                            type="submit"
                                            v-on:click="onComplete"
                                            class="validateBtn col-md-4">
                                            Si
                                        </button>
                                        <button
                                            id="UpdateUser"
                                            type="submit"
                                            v-on:click="goBackForm"
                                            class="validateBtn col-md-4">
                                            No
                                        </button>
                                    </div>
                                    <div class="col-md-4">
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-2 infoForm">
                    </div> 
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import FormDataInscription from '@/views/InfoZone/FormCertificate.vue'
    import FormCertificate from '@/components/Forms.vue'
    import IberoHelpers from '@/store/helpers.js'
    import VEasyDialog from 'v-easy-dialog'

    export default{
        name: "FormCertificated",
        components: {
            FormDataInscription,
            FormCertificate,
            VEasyDialog,
        },
        methods:{
            dataObjCheck: function(InfDaT){
                if(InfDaT === true){
                    return this.$ml.get('Accepted');   
                }
                return this.$ml.get('NotAccepted');    
                },
            closeModal: function () {
                this.simpleDialog = false;
                window.open("https://icebergprod.ibero.edu.co/iceberg-pf/");
            },
            loadFindData: function(restJson){
                debugger
                document.getElementById("IdNombres").readOnly = true;
                document.getElementById("IdApellidos").readOnly = true;
                document.getElementById("IdBanner").readOnly = true;
                document.getElementById("IdQuantity").hidden = true;
                document.getElementById("IdPractice").hidden = true;
                this.formInsModel.IdNombres = restJson.Nombres
                this.formInsModel.IdApellidos = restJson.Apellidos
                this.formInsModel.IdBanner = restJson.IdBanner
                this.formInsModel.IdCellphone = restJson.Celular
                this.formInsModel.IdMail = restJson.EmailPersonal
                this.formInsModel.IdIberoMail = restJson.EmailInstitucional
                this.formInsModel.IdProgram = restJson.CodPrograma
                this.formInsModel.IdModality = restJson.Modalidad
                this.formInsModel.IdWorking = restJson.Jornada
            },
            clearFields: function(){
                document.getElementById("IdNombres").readOnly = false;
                document.getElementById("IdApellidos").readOnly = false;
                document.getElementById("IdBanner").readOnly = false;
                this.formInsModel.IdNombres = ''
                this.formInsModel.IdApellidos = ''
                this.formInsModel.IdBanner = ''
                this.formInsModel.IdCellphone = ''
                this.formInsModel.IdMail = ''
                this.formInsModel.IdIberoMail = ''
                this.formInsModel.IdProgram = ''
                this.formInsModel.IdModality = ''
                this.formInsModel.IdWorking = ''
                this.formInsModel.IdPeriod = ''
                this.formInsModel.IdQuantity = ''
                this.formInsModel.IdPractice = ''
            },
            dataformat: function(InfDaT){
                return IberoHelpers.dataObjDate(InfDaT);
            },
            dataObjFindJs: function(infoDaT,FinDaT){        
                return IberoHelpers.dataObjFind(infoDaT,FinDaT);
            },
            dataObjAllFind: function(infoDaT,FinDaT){        
                return IberoHelpers.dataObjAllFind(infoDaT,FinDaT);
            },
            executeProcess: function (event){
                switch (event.target.id){
                    case "IdDocumentType":
                        this.formInsModel.IdDocument = '';
                    break; 
                    case "IdDocument":
                        if(event.type === 'blur' && this.formInsModel.IdDocumentType !== '' && this.formInsModel.IdDocument !== ''){       
                        debugger
                        var pruebaUser = IberoHelpers.findStudentCertificate(this.$store, this.formInsModel);
                        pruebaUser.then(Response => {
                            debugger
                            if (Response.data !== '') {            
                                this.infoData = false;
                                this.loadFindData(Response.data)
                            }
                            else
                            {
                                this.clearFields()
                                this.infoData = true;
                            }
                        })
                        }
                    break;  
                    case "IdCertificateType":
                        debugger
                        var resultado =  IberoHelpers.dataObjFind(this.$store.state.CertificatesList, this.formInsModel.IdCertificateType);
                        switch(resultado){
                            case "Certificado de Notas (Materias créditos y promedio semestral y general)":
                                document.getElementById("IdQuantity").hidden = false;
                                document.getElementById("IdPractice").hidden = true;
                            break;
                            case "Certificado de Notas Totales":
                                document.getElementById("IdQuantity").hidden = false;
                                document.getElementById("IdPractice").hidden = true;
                            break;
                            case "Certificado Practicas":
                                document.getElementById("IdQuantity").hidden = true;
                                document.getElementById("IdPractice").hidden = false;
                            break;
                            default:
                                document.getElementById("IdQuantity").hidden = true;
                                document.getElementById("IdPractice").hidden = true;
                            break;
                        }
                    break;
                }
            },
            UpdateUser: function() {
                debugger
                return new Promise((resolve, reject) => {
                    this.$refs.obsformCertificate.validate().then(results => {     
                        debugger   
                        if (!results) {
                            IberoHelpers.scrollToTop(0,500);
                            resolve(false)
                        }else{
                            this.showDataInsert();
                            this.FormCertificate = false;
                            this.FormValidate = true;
                            resolve(true)
                        }
                    });
                });
            },
            goBackForm: function(){
                debugger
                this.FormValidate = false;
                this.FormCertificate = true;
                this.formInsModel.IdDocumentType = ''
                this.formInsModel.IdDocument = ''
                this.formInsModel.IdNombres = ''
                this.formInsModel.IdApellidos = ''
                this.formInsModel.IdBanner = ''
                this.formInsModel.IdCellphone = ''
                this.formInsModel.IdMail = ''
                this.formInsModel.IdIberoMail = ''
                this.formInsModel.IdProgram = ''
                this.formInsModel.IdModality = ''
                this.formInsModel.IdWorking = ''
                this.formInsModel.IdPeriod = ''
                this.formInsModel.IdQuantity = ''
                this.formInsModel.IdPractice = ''
                this.formInsModel.IdSendType = ''
                this.formInsModel.IdObservation = ''
                //document.getElementById("IdNombres").readOnly = false;
                //document.getElementById("IdApellidos").readOnly = false;
                //document.getElementById("IdBanner").readOnly = false;
            },
            showDataInsert: function(){
                debugger
                this.NamePerson = this.formInsModel.IdNombres;
                this.LastnamePerson = this.formInsModel.IdApellidos;
                this.IdType = IberoHelpers.dataObjFind(this.$store.state.DocTypesList, this.formInsModel.IdDocumentType);
                this.Identification = this.formInsModel.IdDocument;
                this.Program = IberoHelpers.dataObjFind(this.$store.state.ProgramsList, this.formInsModel.IdProgram);
                this.CertificateType = IberoHelpers.dataObjFind(this.$store.state.CertificatesList, this.formInsModel.IdCertificateType);
                this.PeriodCertificate = this.formInsModel.IdPeriod;
                if(this.formInsModel.IdQuantity != ""){
                    this.QuantityCertificate = this.formInsModel.IdQuantity;
                    this.ValueCertificate = this.formInsModel.IdQuantity * 22095;

                }else{
                    this.QuantityCertificate = 1;
                    this.ValueCertificate = 22095;
                }
            },
            onComplete(){
                debugger
                return new Promise((resolve, reject) => {
                    let loader = this.$loading.show();
                    var resultService = IberoHelpers.sendCaseCertificate(this.$store,this.formInsModel);
                    resultService.then(Response =>{
                        debugger
                        if (!(Response === false)){
                            if (Response.data.status === '200'){
                                IberoHelpers.scrollToTop(0,100);
                                resolve(true);
                                loader.hide();
                                this.goBackForm();
                                //this.infoCorrect = true;
                                this.simpleDialog = true;
                            }
                            else
                            {
                                resolve(false);
                                loader.hide();
                                IberoHelpers.scrollToTop(0,100);
                                this.dangerData = true;
                            }
                        }
                    });
                });
                /*return new Promise((resolve, reject) => {
                    this.$refs.obsformCertificate.validate().then(results => {     
                        debugger   
                        if (!results) {
                            IberoHelpers.scrollToTop(0,500);
                            resolve(false)
                        }else{
                            let loader = this.$loading.show();
                            var resultService = IberoHelpers.sendCaseCertificate(this.$store,this.formInsModel);
                            resultService.then(Response =>{
                                debugger
                                if (!(Response === false)){
                                    if (Response.data.status === '200'){
                                        loader.hide();
                                        IberoHelpers.scrollToTop(0,500);
                                    }
                                }
                            });
                        }
                    });
                });*/
            },
        },
        data(){
            return {
                FormCertificate: true,
                infoData: false,
                infoCorrect: false,
                dangerData: false,
                simpleDialog: false,
                sumaryData: [],
                NamePerson: [],
                LastnamePerson: [],
                IdType: [],
                Identification: [],
                Program: [],
                CertificateType: [],
                PeriodCertificate: [],
                QuantityCertificate: [],
                ValueCertificate: [],
                formInsModel:{
                    Campaign: this.$route.params.referencia,
                    IdDocumentType: '',
                    IdDocument: '',
                    IdNombres: '',
                    IdApellidos: '',
                    IdBanner: '',
                    IdCellphone: '',
                    IdMail: '',
                    IdIberoMail: '',
                    IdProgram: '',
                    IdModality: '',
                    IdWorking: '',
                    IdCertificateType: '',
                    IdPeriod: '',
                    IdQuantity: '',
                    IdPractice: '',
                    IdSendType: '',
                    IdObservation: '',
                },
                formCertificate:[
                    {            
                        id: 'IdDocumentType',
                        model: 'IdDocumentType',
                        //name: 'Tipo de Documento',
                        type: 'Select',  
                        placeholder: "Tipo de Documento",
                        values: this.$store.state.DocTypesList,
                        validate: {              
                            required: true              
                        },
                        class: 'col-md-6',
                    },
                    {            
                        id: 'IdDocument',
                        model: 'IdDocument',
                        //name: 'Documento de Identidad',
                        type: 'input',  
                        placeholder: 'Documento de Identidad',
                        values: '',
                        validate: {              
                        required: true, 
                        min: 5,              
                        max: 12            
                        },
                        class: 'col-md-6',
                    },
                    {            
                        id: 'IdNombres',
                        model: 'IdNombres',
                        //name: 'Nombres',
                        type: 'input',  
                        placeholder: 'Nombres',
                        values: '',
                        readonly:"isReadOnly",
                        validate: {              
                        required: true, 
                        },
                        class: 'col-md-6',
                    },
                    {            
                        id: 'IdApellidos',
                        model: 'IdApellidos',
                        //name: 'Apellidos',
                        type: 'input',  
                        placeholder: 'Apellidos',
                        values: '',
                        validate: {              
                        required: true              
                        },
                        class: 'col-md-6'               
                    },
                    {            
                        id: 'IdBanner',
                        model: 'IdBanner',
                        //name: 'Código Estudiantil',
                        type: 'input',  
                        placeholder: 'Código Estudiantil',
                        values: '',
                        validate: {              
                        required: true, 
                        min: 5,              
                        max: 12            
                        },
                        class: 'col-md-6'               
                    },
                    {            
                        id: 'IdCellphone',
                        model: 'IdCellphone',
                        //name: 'Teléfono Celular',
                        type: 'input',  
                        placeholder: 'Teléfono Celular',
                        values: '',
                        validate: {
                        required: true, 
                        numeric: true,
                        max: 10,
                        min: 10 
                        },  
                        class: 'col-md-6'               
                    },  
                    {            
                        id: 'IdMail',
                        model: 'IdMail',
                        //name: 'Correo Personal',
                        type: 'input',  
                        placeholder: 'Correo Personal',
                        values: '',
                        validate: {
                        required: true, 
                        email: true 
                        },
                        class: 'col-md-6'               
                    },  
                    {            
                        id: 'IdIberoMail',
                        model: 'IdIberoMail',
                        //name: 'Correo Institucional',
                        type: 'input',  
                        placeholder: 'Correo Institucional',
                        values: '',
                        validate: {
                        required: true, 
                        email: true 
                        },
                        class: 'col-md-6'               
                    },
                    {
                        id: 'IdProgram',
                        model: 'IdProgram',
                        //name: 'Programa a Certificar',
                        type: 'Select',  
                        placeholder: 'Programa a Certificar',
                        validate: {              
                        required: true              
                        },
                        class: 'col-md-12',
                        values: this.$store.state.ProgramsList,
                    },
                    {
                        id: 'IdModality',
                        model: 'IdModality',
                        //name: 'Modalidad',
                        type: 'Select',  
                        placeholder: 'Modalidad',
                        validate: {              
                        required: true              
                        },
                        class: 'col-md-6',
                        values: this.$store.state.ModalitiesList,
                    },
                    {
                        id: 'IdWorking',
                        model: 'IdWorking',
                        //name: 'Jornada',
                        type: 'Select',  
                        placeholder: 'Jornada',
                        validate: {              
                        required: true              
                        },
                        class: 'col-md-6',
                        values: this.$store.state.WorkdayList,
                    },
                    {
                        id: 'IdCertificateType',
                        model: 'IdCertificateType',
                        //name: 'Tipo de Certificación o Duplicado',
                        type: 'Select',  
                        placeholder: 'Tipo de Certificación o Duplicado',
                        validate: {              
                        required: true              
                        },
                        class: 'col-md-12',
                        values: this.$store.state.CertificatesList,
                    },
                    {
                        id: 'IdPeriod',
                        model: 'IdPeriod',
                        //name: 'Periodo Académico a Certificar',
                        type: 'Select',  
                        placeholder: 'Periodo Académico a Certificar',
                        validate: {              
                        required: true              
                        },
                        class: 'col-md-6',
                        values: [
                            { id: "1", value: "1" },
                            { id: "2", value: "2" },
                            { id: "3", value: "3" },
                            { id: "4", value: "4" },
                            { id: "5", value: "5" },
                            { id: "6", value: "6" },
                            { id: "7", value: "7" },
                            { id: "8", value: "8" },
                            { id: "9", value: "9" },
                            { id: "10", value: "10" }
                        ],
                    },
                    {
                        id: 'IdQuantity',
                        model: 'IdQuantity',
                        //name: 'Cantidad de Periodos',
                        type: 'Select',  
                        placeholder: 'Cantidad de Periodos',
                        validate: {              
                        required: false              
                        },
                        class: 'col-md-6',
                        values: [
                            { id: "1", value: "1" },
                            { id: "2", value: "2" },
                            { id: "3", value: "3" },
                            { id: "4", value: "4" },
                            { id: "5", value: "5" },
                            { id: "6", value: "6" },
                            { id: "7", value: "7" },
                            { id: "8", value: "8" },
                            { id: "9", value: "9" },
                            { id: "10", value: "10" }
                        ],
                    },
                    {            
                        id: 'IdPractice',
                        model: 'IdPractice',
                        //name: 'Nombres',
                        type: 'input',  
                        placeholder: 'Sitio de Práctica',
                        values: '',
                        readonly:"isReadOnly",
                        validate: {              
                        required: false, 
                        },
                        class: 'col-md-12',
                    },
                    {
                        id: 'IdSendType',
                        model: 'IdSendType',
                        //name: 'Tipo de Envío',
                        type: 'Select',  
                        placeholder: 'Tipo de Envío',
                        validate: {              
                        required: true              
                        },
                        class: 'col-md-12',
                        values: [
                            { id: "Oficina (ASE) Bogotá", value: "Oficina (ASE) Bogotá" },
                            { id: "Correo Electrónico", value: "Correo Electrónico" },
                        ],
                    },  
                    {            
                        id: 'IdObservation',
                        model: 'IdObservation',
                        //name: 'Mensaje',
                        type: 'textarea',
                        hint: "Max 500 caracteres",
                        max: 500,
                        placeholder: 'Mensaje',
                        rows: 5,
                        values: '',
                        validate: 
                        {
                            required: false, 
                        },
                        class: 'col-md-12',
                        styleClasses: 'height: 200px'            
                    }, 
                ]
            }
        }
    }
</script>

<style scope>
.infoTitleValid{
    font-size: 18px;
    margin: 0px 0px 0px 12px;
}
.InscPayOrder{
    margin: 20px;
}
.totalformList{
    margin-bottom: 10px;
}
.img-fluid{
    cursor: pointer;
    margin-left: 10px;
    margin-right: 10px;    
}

.txtBusUser{
    padding: 40px;
}

.titleRef {
    font-weight: bold;
    padding-bottom: 0px;
    margin-top: 20px;
}

.titleForm {
    color: #000;
}

.descriptionForm {
    padding: 10px 10px 0px 10px;
    font-size: 12px;
    margin: 0px;
}

.lisDataUser{
    padding: 10px;
    border-radius: 10px 10px 10px 10px;
    -moz-border-radius: 10px 10px 10px 10px;
    -webkit-border-radius: 10px 10px 10px 10px;
    border: 0px solid #ffffff;
    background:  #ffffff !important;       
    margin-bottom: 5px;
}

.container-form{
    padding: 30px 0;
    box-sizing: border-box;
}

.motBusUser{
    padding: 10px 10px 0px 10px;
    border-radius: 5px 5px 5px 5px;
    -moz-border-radius: 5px 5px 5px 5px;
    -webkit-border-radius: 5px 5px 5px 5px;
    background:  #ffffff !important;       
}

body {
    background:  #fff !important;   
}
header {
    background:  #ffffff !important;   
}

.table > tbody > tr > td {
    vertical-align: middle !important;
}

.linksActas{
    padding: 20px;
    float: right;
}

.linksReference{
    margin-top: 20px;
    padding: 20px;
    float: right;
}

.linksActas a {
    color: #222;
}

.active
{
    color: #222;
}

#IdObservation {
    height: 90px;
}

.botoPnrocess {
    text-align: center;
    margin-top: 0px;
    margin-bottom: 10px;
}
button:hover {
    background-color: #222;
    color: #fff;
}
.loginbtn {
    width: 90%;
    border: #222 solid 1px !important;
    background-color: #fff;
    color: #222;
    border-radius: 10px 10px;
    padding: 10px 0px 10px 0px;
}

.validateBtn{
    width: 90%;
    border-color: #222;
    background-color: #fff;
    color: #222;
    border-radius: 10px 10px;
    padding: 10px 0px 10px 0px;
    margin: 0px 10px 10px 10px;
}

/* Modal validación de datos */
.InscFiles{
    margin: 20px;
}

/* Grid validación data */
.wrapper {
  display: grid;
  margin: 10px 10px 10px 10px;
  padding: 1px 1px 1px 1px;
  grid-template-columns: repeat(2, 1fr);
  border: 1px solid black;
  grid-gap: 1px;
  background-color: black;
}

.wrapper > div {
  background-color: white;
  padding: 10px;
  text-align: center;
}

/* Estilos dedicados al Modal */
#btnClose{
    margin: 10px 10px 10px 10px;
    border-radius: 5px;
    border-color: #222;
    background-color: #fff;
    color: #222;
}
#btnClose:hover{
    background-color: #222;
    color: #fff;
}
hr{
    margin: 5px 10px;
}
.titleModal{
    font-size: 20px !important;
}
.v-easy-dialog--transition-ease-in {
    transform: scale(1);
    transition: opacity cubic-bezier(0.4, 0, 1, 1) 0.15s,
        transform cubic-bezier(0.4, 0, 1, 1) 0.15s;
}
.v-easy-dialog--transition-ease-out {
    transform: scale(1);
    transition: opacity cubic-bezier(0, 0, 0.2, 1) 0.15s,
        transform cubic-bezier(0, 0, 0.2, 1) 0.15s;
}
.v-easy-dialog--content-transition-opened {
    opacity: 1;
    transform: scale(1);
}
.v-easy-dialog--content-transition-closed {
    opacity: 0;
    transform: scale(0);
}
.v-easy-dialog--opacity-0 {
    opacity: 0;
}
.v-easy-dialog--opacity-100 {
    opacity: 100;
}
.v-easy-dialog--backdrop {
    z-index: 1050;
    display: flex;
    justify-content: center;
    align-items: center;
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    touch-action: none;
}
.v-easy-dialog--backdrop-btn {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    width: 100%;
    height: 100%;
    cursor: default;
}
.v-easy-dialog--backdrop-btn:hover{
    background-color: rgba(0, 0, 0, 0) !important;
}
.v-easy-dialog--fullscreen {
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    width: 100%;
    height: 100%;
}
.v-easy-dialog--content-grow *:first-child {
    flex-grow: 1;
}
.v-easy-dialog--content-container {
    display: flex;
    overflow-y: auto;
    position: absolute;
    touch-action: none;
}
.v-easy-dialog--content-container:focus {
    outline: none;
}
.v-easy-dialog--persist {
    animation: shake 0.15s;
}

.textSend{
    background-color: #fff;
    border-radius: 10px;
}

.textSend div p{
    padding: 10px 10px 10px 10px;
    margin: 0px 0px 0px 0px;
    color: #000;
    font-size: 15px;
}
@keyframes shake {
    0% {
        transform: translate(1px, 1px) rotate(0deg);
    }
    20% {
        transform: translate(-3px, 0px) rotate(1deg);
    }
    40% {
        transform: translate(1px, -1px) rotate(1deg);
    }
    60% {
        transform: translate(-3px, 1px) rotate(0deg);
    }
    80% {
        transform: translate(-1px, -1px) rotate(1deg);
    }
    100% {
        transform: translate(1px, -2px) rotate(-1deg);
    }
}

</style>